<template>
    <div id="app">
        <nav-bar title="Campus Calendar" :routes="routes"></nav-bar>
        <router-view></router-view>
    </div>
</template>

<script>
import NavBar from '../components/NavBar.vue';
export default {
    name: 'app',
    components: {
        NavBar
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser;
        }
    },
    created() {
        this.checkCurrentLogin();
    },
    updated() {
        this.checkCurrentLogin();
    },
    methods: {
        checkCurrentLogin() {
            var route = this.$router.options.routes.find(rt=>rt.path == this.$route.path);
            if (!this.currentUser && route.protected) {
                this.$router.push('/login?destination=' + this.$route.path);
            }
        }
    }
};
</script>

<!-- Popover styles, part of a mixin -->
<style src="../css/popover.css"></style>